import request from '../utils/request'

export function fetchList () {
  const query = {
    page: 1,
    count: 2,
    type: 'video',
  }
  // /mini/userMemberInfo

  return request({
    url: '/mini/userMemberInfo',
    method: 'post',
    params: query,
  })
}

// 公众号网页登录
export function fetchLogin (params) {
  console.log(params, 'params')
  return request({
    // url: '/mini/userTaskInfo',
    url: '/h5/wxPublicGetUserOpenId',
    method: 'post',
    data: params,
  })
}

// 调起支付所需参数
export function fetchOrderWxPublicOrderCreate (params) {
  return request({
    url: '/h5/orderWxPublicOrderCreate',
    method: 'post',
    data: params,
  })
}
// 跳转小程序所需参数
export function fetchWxGetJsSdkSignature () {
  return request({
    url: '/h5/wxGetJsSdkSignature',
    method: 'post',
  })
}

// 充值月份Vip列表
export function fetchUserMemberInfoList () {
  return request({
    url: '/mini/userMemberInfo',
    method: 'post',
    // params: query
  })
}

// 用户获取任务信息
export function fetchUserTaskInfo () {
  return request({
    url: '/mini/userTaskInfo',
    method: 'post',
  })
}
